import React, {useMemo} from 'react';
import {Field, FieldArray, reduxForm} from 'redux-form'
import Button from "@material-ui/core/Button";
import {useTranslation} from "react-i18next";
import makeStyles from "@material-ui/core/styles/makeStyles";
import ChipsSelect from "../../../reduxFormComponents/ChipsSelect";
import {useFetchOnce} from "../../../../hooks/useFetchOnce";
import {getProfessions, getSubProfessions} from "../../../../api";
import ActivityLine from "./ActivityLine";
import {connect} from "react-redux";
import {Box, Typography} from "@material-ui/core";
import useRunOnceWhenTruthy from "../../../../hooks/useRunOnceWhenTruthy";

const useStyles = makeStyles((theme) => ({
    root: {
        flex: 1,
        padding: theme.spacing(1),
        paddingBottom: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        overflow:'hidden'
    },
    fields: {
        flex: '1',
        overflow:'auto',
        paddingTop:theme.spacing(1)
    },
    field: {
        marginBottom: theme.spacing(4),
    },
    actions: {
        paddingTop:theme.spacing(1),
        display: 'flex',
        justifyContent: 'center'
    },
    nextButton: {
        width: theme.bigButtonSize,
        marginLeft: theme.spacing(4)
    }

}));

const ChooseProfession = ({selectedProfession, handleBack, change, editMode, handleSubmit}) => {
    const subProfessionsData = useFetchOnce(getSubProfessions);
    const professionsOptions = useFetchOnce(getProfessions);

    const subProfessionsFilterOptions = useMemo(() => subProfessionsData?.filter(profession => profession.professionId === selectedProfession?._id), [subProfessionsData, selectedProfession])

    useRunOnceWhenTruthy(() => {
        if (selectedProfession?.heName === null) {
            const selectedOption = professionsOptions.find(({_id}) => selectedProfession._id)
            if (selectedOption) {
                change('profession', selectedOption)
            }

        }
    }, professionsOptions.length)

    const classes = useStyles()
    const {t} = useTranslation();
    return <form onSubmit={handleSubmit} className={classes.root}>
        <Box display={'flex'} justifyContent={'center'} pb={2}>
            <Typography variant={"body2"} gutterBottom>{t('profession_explanation')}</Typography>
        </Box>
        <div className={classes.fields}>
            <Field name="profession" className={classes.field} component={ChipsSelect} label={t('profession')}
                   options={professionsOptions} loading={!professionsOptions}/>
            <FieldArray name="activities" component={ActivityLine} subProfessions={subProfessionsFilterOptions}/>
        </div>
        <div className={classes.actions}>
            <Button color="primary" variant="outlined" onClick={handleBack}>
                {t('back')}
            </Button>
            <Button type="submit" color="primary" variant="contained" className={classes.nextButton}>
                {t('next')}
            </Button>
        </div>
    </form>
}

const ConnectedChooseProfession = connect(state => ({
    selectedProfession: state.form.signupSupplierForm?.values?.profession
}))(ChooseProfession)

export default reduxForm({
    form: 'signupSupplierForm',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(ConnectedChooseProfession);
